// extracted by mini-css-extract-plugin
export var dataCell = "_pz-2";
export var dataRow = "_pz-0";
export var headerRow = "_pz-1";